import { render } from "./PaymentReceiptDetailTabDocuments.vue?vue&type=template&id=1d161bda"
import script from "./PaymentReceiptDetailTabDocuments.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptDetailTabDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__